<div class="verify-email">
  <mat-card appearance="outlined" class="verify-card">
    <mat-card-content>

      <!-- Loading -->
      <div *ngIf="status === 'loading'" class="verify-state">
        <mat-spinner diameter="48" class="verify-spinner"></mat-spinner>
        <p class="verify-message">Verifying your email address...</p>
      </div>

      <!-- Success -->
      <div *ngIf="status === 'success'" class="verify-state">
        <mat-icon class="verify-icon verify-icon--success">check_circle</mat-icon>
        <h2 class="verify-title">Thank you for verifying</h2>
        <p class="verify-message">Your email address has been verified. You can now sign in.</p>
        <button mat-raised-button color="primary" routerLink="/sign-in" class="verify-action">
          Continue to Sign In
        </button>
      </div>

      <!-- Expired or already used: offer a resend -->
      <div *ngIf="status === 'expired' || status === 'used'" class="verify-state">
        <mat-icon class="verify-icon verify-icon--warn">schedule</mat-icon>
        <h2 class="verify-title">
          <span *ngIf="status === 'expired'">This link has expired</span>
          <span *ngIf="status === 'used'">This link has already been used</span>
        </h2>

        <ng-container *ngIf="!resendSent">
          <p class="verify-message">Enter your email address and we will send you a new verification link.</p>
          <form (submit)="onResend(rf)" #rf="ngForm" class="verify-form">
            <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Email Address</mat-label>
              <input
                matInput
                type="email"
                email
                required
                name="resendEmail"
                [(ngModel)]="resendEmail"
                placeholder="you@example.com" />
            </mat-form-field>
            <button mat-raised-button color="primary" type="submit" [disabled]="!rf.valid" class="verify-action">
              Send New Verification Link
            </button>
          </form>
        </ng-container>

        <p *ngIf="resendSent" class="verify-message">
          If that address needs verification, a new link has been sent. Please check your email.
        </p>

        <button type="button" mat-button routerLink="/sign-in" class="verify-link">
          Back to Sign In
        </button>
      </div>

      <!-- Unknown or invalid -->
      <div *ngIf="status === 'unknown'" class="verify-state">
        <mat-icon class="verify-icon verify-icon--warn">error_outline</mat-icon>
        <h2 class="verify-title">Invalid verification link</h2>
        <p class="verify-message">
          This verification link is invalid. Please check the link, or request a new one from the sign in page.
        </p>
        <button type="button" mat-button routerLink="/sign-in" class="verify-link">
          Back to Sign In
        </button>
      </div>

    </mat-card-content>
  </mat-card>
</div>
